import React, { useMemo } from 'react';
import DsModal from '../../DsModal';
import { CHAT_REACTION_CONFIG_MAP } from '../shared/chatReactionConfig';
import PersonAvatar from '../../avatar/PersonAvatar';
import '../../../../css/common/chat/ChatMessageReactions.css';

const ChatMessageReactionDetailModal = ({
  open = false,
  loading = false,
  groups = [],
  onClose = null,
}) => {
  const renderDisplayName = (displayName, partName) => {
    const normalizedPartName = String(partName || '').trim();
    return (
      <>
        <span>{displayName}</span>
        {normalizedPartName ? (
          <span className="chat-message-reaction-detail-modal__part">（{normalizedPartName}）</span>
        ) : null}
      </>
    );
  };
  const reactors = useMemo(() => {
    const safeGroups = Array.isArray(groups) ? groups : [];
    const flattened = [];
    safeGroups.forEach((group) => {
      const reactionType = String(group?.type || '').trim();
      if (!reactionType) return;
      const config = CHAT_REACTION_CONFIG_MAP[reactionType] || null;
      (Array.isArray(group?.reactors) ? group.reactors : []).forEach((reactor, index) => {
        const displayName = String(reactor?.displayName || '').trim() || '—';
        const isArtist = reactor?.actorType === 'artist';
        const profilePicture = String(reactor?.profilePicture || '').trim();
        flattened.push({
          ...reactor,
          displayName,
          actorType: isArtist ? 'artist' : 'admin',
          gender: reactor?.gender || reactor?.artist_gender || '',
          profilePicture,
          reactionType,
          reactionIconClassName: config?.iconClassName || '',
          sortIndex: index,
        });
      });
    });
    flattened.sort((left, right) => {
      const leftTime = left?.reactedAt ? new Date(left.reactedAt).getTime() : 0;
      const rightTime = right?.reactedAt ? new Date(right.reactedAt).getTime() : 0;
      if (leftTime !== rightTime) return rightTime - leftTime;
      return String(left?.displayName || '').localeCompare(String(right?.displayName || ''));
    });
    return flattened;
  }, [groups]);

  return (
    <DsModal open={open} onClose={onClose} title="リアクション" size="sm">
      <div className="chat-message-reaction-detail-modal__body">
        {loading ? <div className="chat-message-reaction-detail-modal__empty">読み込み中...</div> : null}
        {!loading && !reactors.length ? (
          <div className="chat-message-reaction-detail-modal__empty">リアクションはありません。</div>
        ) : null}
        {!loading && reactors.map((reactor) => (
          <div key={`${reactor.actorType}:${reactor.actorId}:${reactor.reactedAt || ''}`} className="chat-message-reaction-detail-modal__row">
            <PersonAvatar
              role={reactor.actorType}
              gender={reactor.gender}
              name={reactor.displayName}
              profilePicture={reactor.profilePicture}
              className={`chat-message-reaction-detail-modal__avatar ${reactor.profilePicture ? 'has-image' : ''}`}
              variant="proxy"
              size={40}
              ariaHidden
            />
            <div className="chat-message-reaction-detail-modal__info">
              <div className="chat-message-reaction-detail-modal__name">
                {renderDisplayName(reactor.displayName, reactor.partName)}
              </div>
              <div
                className="chat-message-reaction-detail-modal__reaction"
                data-reaction-type={reactor.reactionType}
              >
                {reactor.reactionIconClassName ? (
                  <i className={reactor.reactionIconClassName} aria-hidden="true"></i>
                ) : null}
              </div>
            </div>
          </div>
        ))}
      </div>
    </DsModal>
  );
};

export default ChatMessageReactionDetailModal;
